import type { UseFormReturn } from 'react-hook-form';

import { FormDateInput, FormField, FormInput } from '@/_components';
import { BirthdateInput, EmailsForm, FormInputUrl } from '@/_containers';

import type { ContactFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  isCreate = false,
}: {
  form: UseFormReturn<ContactFormSchema>;
  handlePageEmailsUpdate?: (v: ContactFormSchema['emails']) => Promise<unknown>;
  isEditable?: boolean;
  isCreate?: boolean;
}) {
  return (
    <>
      {!isCreate && (
        <>
          <FormField
            control={form.control}
            name="first_name"
            render={({ field }) => (
              <FormInput
                formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
                label="First Name (required)"
                {...field}
                disabled={!isEditable}
              />
            )}
          />

          <FormField
            control={form.control}
            name="last_name"
            render={({ field }) => (
              <FormInput
                formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
                label="Last Name"
                {...field}
                disabled={!isEditable}
              />
            )}
          />
        </>
      )}

      <div className={`col-span-12 sm:col-span-6 ${isCreate ? '' : 'lg:col-span-4'}`}>
        <EmailsForm isEditable={isEditable} />
      </div>

      {!isCreate && (
        <FormField
          control={form.control}
          name="title"
          render={({ field }) => (
            <FormInput
              label="Title"
              formItemClassName="col-span-12 sm:col-span-6 2xl:col-span-3"
              {...field}
              disabled={!isEditable}
            />
          )}
        />
      )}

      <BirthdateInput isCreate={isCreate} isEditable={isEditable} />

      {!isCreate && (
        <FormField
          control={form.control}
          name="work_anniversary"
          render={({ field: { value, onChange } }) => (
            <FormDateInput
              disabled={!isEditable}
              formItemClassName="col-span-12 sm:col-span-6 2xl:col-span-3"
              label="Work Anniversary"
              value={value}
              maxDate={new Date()}
              onValueChange={onChange}
            />
          )}
        />
      )}

      {!isCreate && (
        <FormField
          control={form.control}
          name="wedding_anniversary"
          render={({ field: { value, onChange } }) => (
            <FormDateInput
              disabled={!isEditable}
              formItemClassName="col-span-12 sm:col-span-6 2xl:col-span-3"
              label="Wedding Anniversary"
              maxDate={new Date()}
              value={value}
              onValueChange={onChange}
            />
          )}
        />
      )}

      <FormField
        control={form.control}
        name="linked_in_url"
        render={({ field }) => (
          <FormInputUrl
            label="LinkedIn"
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-6"
            {...field}
            disabled={!isEditable}
            value={field.value}
          />
        )}
      />

      <FormField
        control={form.control}
        name="twitter_handle"
        render={({ field }) => (
          <FormInputUrl
            label="X (Twitter)"
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-6"
            {...field}
            disabled={!isEditable}
            value={field.value}
          />
        )}
      />

      {!isCreate && (
        <FormField
          control={form.control}
          name="spouse_name"
          render={({ field }) => (
            <FormInput
              formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
              label="Spouse Name"
              {...field}
              disabled={!isEditable}
            />
          )}
        />
      )}

      {!isCreate && (
        <FormField
          control={form.control}
          name="children_names"
          render={({ field }) => (
            <FormInput
              formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
              label="Children Names"
              {...field}
              disabled={!isEditable}
            />
          )}
        />
      )}

      {!isCreate && (
        <FormField
          control={form.control}
          name="pet_names"
          render={({ field }) => (
            <FormInput
              formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
              label="Pet Names"
              {...field}
              disabled={!isEditable}
            />
          )}
        />
      )}
    </>
  );
}
